import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ICourse } from '@interfaces/ICourse';
import { environment } from '../../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class CoursesService {
  constructor(private _http: HttpClient) {}

  createCourse(course: ICourse): Observable<ICourse> {
    const url = `${environment.baseUrl}api/v1/courses/`;
    return this._http.post<ICourse>(url, course);
  }

  getCourses(): Observable<ICourse[]> {
    const url = `${environment.baseUrl}api/v1/courses/`;
    return this._http.get<ICourse[]>(url);
  }

  getCourse(id: number): Observable<ICourse> {
    const url = `${environment.baseUrl}api/v1/courses/${id}/`;
    return this._http.get<ICourse>(url);
  }

  editCourse(id: number, course: ICourse): Observable<ICourse> {
    const url = `${environment.baseUrl}api/v1/courses/${id}/`;
    return this._http.put<ICourse>(url, course);
  }

  deactivateCourse(id: number): Observable<ICourse> {
    const url = `${environment.baseUrl}api/v1/courses/${id}/`;
    return this._http.patch<ICourse>(url, { is_active: false });
  }

  activateCourse(id: number, related_groups?: number[]): Observable<ICourse> {
    const url = `${environment.baseUrl}api/v1/courses/${id}/`;
    return this._http.patch<ICourse>(url, { is_active: true, related_groups });
  }

  deleteCourse(id: number): Observable<{ detail: string }> {
    const url = `${environment.baseUrl}api/v1/courses/${id}/`;
    return this._http.delete<{ detail: string }>(url);
  }
}
